import { render, staticRenderFns } from "./FloatingPreview.vue?vue&type=template&id=38b17c72&scoped=true"
import script from "./FloatingPreview.vue?vue&type=script&lang=js"
export * from "./FloatingPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b17c72",
  null
  
)

export default component.exports